import { CameraIcon } from '@radix-ui/react-icons'
import { TooltipWrapper } from 'components/TooltipWrapper'
import { useGeckoAnalytics } from 'features/analytics'
import { KestrelCommands } from 'features/kestrelViewer/types/KestrelCommands'
import { useKestrelViewerContext } from 'features/kestrelViewer/types/KestrelViewerInterfaces'
import { ViewToggle } from 'features/kestrelViewer/ui/tools/ViewToggle'
import React, { FC, useEffect, useState } from 'react'
import { KVCameraPose } from 'types'

export const ToggleCameraPosesButton: FC = () => {
  const { kestrelModel, cameraPoses, sendCommand } = useKestrelViewerContext()
  const { trackButtonClicked } = useGeckoAnalytics()
  const [cameraPosesVisible, setCameraPosesVisible] = useState(false)

  useEffect(() => {
    if (cameraPoses) {
      const cameraPosesJson = cameraPoses.map((pose: KVCameraPose) =>
        KVCameraPose.toJSON(pose)
      )
      sendCommand({
        command: KestrelCommands.SET_CAMERA_POSES,
        cameraPoses: cameraPosesJson,
        cameraPosesVisible: cameraPosesVisible,
      })
    }
  }, [cameraPoses, cameraPosesVisible, sendCommand])

  // Toggle camera poses visibility and send command to Kestrel
  const handleClick = () => {
    setCameraPosesVisible(!cameraPosesVisible)
    sendCommand({
      command: KestrelCommands.SET_CAMERA_POSES_VISIBILITY,
      cameraPosesVisible: !cameraPosesVisible,
    })
    trackButtonClicked({
      button_name: 'kestrel_toggle_camera_poses',
      kestrel_model_id: kestrelModel?.data.kestrel_model_id,
    })
  }

  // Only show if photos are enabled
  if (!kestrelModel?.id || !kestrelModel?.data.photosEnabled) {
    return null
  }

  return (
    <TooltipWrapper side={'top'} offset={5} label={'Toggle Camera Poses'}>
      <ViewToggle onClick={handleClick}>
        <CameraIcon
          style={{ color: cameraPosesVisible ? 'white' : 'gray' }}
          width={22}
          height={22}
        />
      </ViewToggle>
    </TooltipWrapper>
  )
}
